/**
 * Validates and normalizes phone number to E.164 format
 */
export function normalizePhone(phone) {
  const str = String(phone || "").trim();
  if (/^\+[1-9]\d{6,14}$/.test(str)) return str;
  // Try adding + prefix for numbers stored without it (e.g. "91xxxxxxxxxx")
  const withPlus = `+${str}`;
  if (/^\+[1-9]\d{6,14}$/.test(withPlus)) return withPlus;
  return "";
}
